import PageLayer from "@/Layouts/views/PageLayer";
import PositionMappingLayer from "../../components/PositionMapping/PositionMappingLayer";

// Icons
import iconPM from "@/assets/icons/settings/possition-mapping-icon.svg";

// MUI
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import DoneIcon from "@mui/icons-material/Done";

import { SnackbarProvider } from "notistack";
import { SnackbarsCustomStyle, AUTO_HIDE_DURATION, MAX_SNACK } from "@Layouts/components/Snackbars";

export default function PositionMappingView() {
	return (
		<SnackbarProvider
			maxSnack={MAX_SNACK}
			anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
			autoHideDuration={AUTO_HIDE_DURATION}
			iconVariant={{ 
				error: <ErrorOutlineRoundedIcon fontSize="small" className="mr-2" />,
				success: <DoneIcon fontSize="small" className="mr-2" /> 
			}}
			Components={{
				error: SnackbarsCustomStyle,
				success: SnackbarsCustomStyle
			}}
		>
			<PageLayer title="Position Mapping" icon={iconPM}>
				<PositionMappingLayer />
			</PageLayer>
		</SnackbarProvider>
	);
}
